import {register} from '../vendor/theme-scripts/theme-sections';
import drawer from '../features/header-mobile-drawer';
import stickyHeader from '../features/header-sticky';
import hoverDisclosure from '../features/header-hover-disclosure';
import headerTotals from '../features/header-totals';
import headerMobileSliderule from '../features/header-mobile-sliderule';

const selectors = {
  wrapper: '[data-header-wrapper]',
  style: 'data-header-style',
  widthContentWrapper: '[data-takes-space-wrapper]',
  widthContent: '[data-child-takes-space]',
  desktop: '[data-header-desktop]',
  headerHeight: '[data-header-height]',
  cloneClass: 'js__header__clone',
  showMobileClass: 'js__show__mobile',
  deadLink: '.navlink[href="#"]',
  cartToggleButton: '[data-cart-toggle]',
  firstSectionOverlayHeader: '.main-content > .shopify-section.section-overlay-header:first-of-type',
};

const classes = {
  transparent: 'has-header-transparent',
  firstSectionOverlayHeader: 'has-first-section-overlay-header',
};

const attributes = {
  transparent: 'data-header-transparent',
};

let sections = {};

class Header {
  constructor(el) {
    this.wrapper = el;
    this.style = this.wrapper.dataset.style;
    this.desktop = this.wrapper.querySelector(selectors.desktop);
    this.deadLinks = document.querySelectorAll(selectors.deadLink);
    this.resizeObserver = null;
    this.checkWidth = this.checkWidth.bind(this);

    this.killDeadLinks();
    if (this.style !== 'drawer' && this.desktop) {
      this.minWidth = this.getMinWidth();
      this.listenWidth();
    }

    this.cartToggleEvent();

    // Fallback for CSS :has() selectors
    const firstSectionOverlayHeader = document.querySelector(selectors.firstSectionOverlayHeader);
    document.body.classList.toggle(classes.transparent, this.wrapper.hasAttribute(attributes.transparent));
    document.body.classList.toggle(classes.firstSectionOverlayHeader, firstSectionOverlayHeader);
  }

  listenWidth() {
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.checkWidth);
      this.resizeObserver.observe(this.wrapper);
    } else {
      document.addEventListener('theme:resize', this.checkWidth);
    }
  }

  killDeadLinks() {
    this.deadLinks.forEach((el) => {
      el.onclick = (e) => {
        e.preventDefault();
      };
    });
  }

  checkWidth() {
    if (document.body.clientWidth < this.minWidth) {
      this.wrapper.classList.add(selectors.showMobileClass);
    } else {
      this.wrapper.classList.remove(selectors.showMobileClass);
    }

    const headerHeight = this.wrapper.querySelector(selectors.headerHeight).offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }

  getMinWidth() {
    const comparitor = this.wrapper.cloneNode(true);
    comparitor.classList.add(selectors.cloneClass);
    document.body.appendChild(comparitor);
    const widthWrappers = comparitor.querySelectorAll(selectors.widthContentWrapper);
    let minWidth = 0;
    let spaced = 0;

    widthWrappers.forEach((context) => {
      const wideElements = context.querySelectorAll(selectors.widthContent);
      let thisWidth = 0;
      if (wideElements.length === 3) {
        thisWidth = _sumSplitWidths(wideElements);
      } else {
        thisWidth = _sumWidths(wideElements);
      }
      if (thisWidth > minWidth) {
        minWidth = thisWidth;
        spaced = wideElements.length * 20;
      }
    });

    document.body.removeChild(comparitor);
    return minWidth + spaced;
  }

  cartToggleEvent() {
    const cartToggleButtons = this.wrapper.querySelectorAll(selectors.cartToggleButton);
    if (cartToggleButtons.length) {
      cartToggleButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();

          document.dispatchEvent(new CustomEvent('theme:cart:toggle', {bubbles: true}));
        });
      });
    }
  }

  unload() {
    if ('ResizeObserver' in window) {
      this.resizeObserver?.unobserve(this.wrapper);
    } else {
      document.removeEventListener('theme:resize', this.checkWidth);
    }
  }
}

function _sumSplitWidths(nodes) {
  let arr = [];
  nodes.forEach((el) => {
    if (el.firstElementChild) {
      arr.push(el.firstElementChild.clientWidth);
    }
  });
  if (arr[0] > arr[2]) {
    arr[2] = arr[0];
  } else {
    arr[0] = arr[2];
  }
  const width = arr.reduce((a, b) => a + b);
  return width;
}
function _sumWidths(nodes) {
  let width = 0;
  nodes.forEach((el) => {
    width += el.clientWidth;
  });
  return width;
}

const header = {
  onLoad() {
    sections = new Header(this.container);
  },
  onUnload() {
    if (typeof sections.unload === 'function') {
      sections.unload();
    }
  },
};

register('header', [header, drawer, headerMobileSliderule, stickyHeader, hoverDisclosure, headerTotals]);
